import { useApi, createApiHook } from "../utils/apiUtils";

const hasAggregate = (data) =>
  data && typeof data === "object" && ["created", "updated", "errors", "created_items", "updated_items"].some((k) => k in data);

const useUploadExcelForAssignapps = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const uploadExcel = async (file) => {
    if (!file) return { ok: false };

    startLoading();

    const formData = new FormData();
    formData.append("file", file);

    const response = await apiPost("/assignapps/import_from_xlsx", "Error al subir el archivo Excel", formData, {
      "Content-Type": "multipart/form-data",
    });

    setResponse(response);

    const okParaModal = hasAggregate(response?.data);

    return {
      ok: okParaModal,
      data: response?.data,
      status: response?.status,
      errorMessage:
        typeof response?.error === "string" ? response.error : response?.error?.message || response?.data?.message || response?.message || null,
    };
  };

  return { uploadExcel, data, error, loading };
};

export default useUploadExcelForAssignapps;
